import React from 'react'
import '../css/Ipod.css'
import FastForwardRoundedIcon from '@material-ui/icons/FastForwardRounded';
import FastRewindRoundedIcon from '@material-ui/icons/FastRewindRounded';
import PlayArrowRoundedIcon from '@material-ui/icons/PlayArrowRounded';
import PauseIcon from '@material-ui/icons/Pause';
import DisplayController from './DisplayController';
import { useState,useEffect } from 'react';
import ZingTouch from 'zingtouch';

export default function Ipod() {
    useEffect(() => {
        var target = document.getElementById('ipodRotatingMenu');
        var region = new ZingTouch.Region(target);
        region.bind(target, 'rotate', function(e) {
            changeMenu(e.detail.angle,setMenu);
        });
      });
    const [menu,setMenu] = useState("1");
    const [screen, setScreen] = useState("0");
    return (
        <div>
            <div id="ipodFrame">
                <div id="ipodDisplay">
                    <DisplayController menu={menu} screen={screen}/>
                </div>
                <div id="ipodMenu">
                    <div id="ipodRotatingMenu">
                        <span className="top" onClick={()=>setScreen("0")}>MENU</span>
                        <span className="left"><FastRewindRoundedIcon/></span>
                        <span className="right"><FastForwardRoundedIcon/></span>
                        <span className="bottom"><PlayArrowRoundedIcon/><PauseIcon/></span>
                        <div id="ipodCenterMenu" onClick={()=>setScreen(menu)}>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

function changeMenu(deg,setMenu){
    if(0 < deg && deg < 90){
        setMenu("1");
    }else if(90 < deg && deg < 180){
        setMenu("2");
    }else if(180 < deg && deg < 270){
        setMenu("3");
    }else if(270 < deg && deg <= 360){
        setMenu("4");
    }
}